(function () {

    "use strict";

    function TranslationsController($translate, tmhDynamicLocale) {

        var vm = this;

        vm.changeLanguage = changeLanguage;

        // -------------------------------

        function changeLanguage(langKey) {
            if (langKey) {
                var currentLanguage = $translate.use();

                if (currentLanguage !== langKey) {
                    $translate.use(langKey);
                    tmhDynamicLocale.set(langKey);
                }
            }
        }
    }

    TranslationsController.$inject = ["$translate", "tmhDynamicLocale"];

    angular.module("sphforms.translate")
        .component("sphformsChangeLanguage", {
            controller: TranslationsController,
            templateUrl: "modules/translate/components/changeLanguage/changeLanguage.template.html"
        });

}());
